export default __webpack_public_path__ + "static/media/Sarthak.317927b2.pdf";